import { FC, PropsWithChildren, SVGProps, useState } from 'react'
import { ArrowUpDownIcon, LucideIcon } from 'lucide-react'
import TransferIcon from '@/ui/assets/transfer.svg'
import { Button } from '@/ui/atoms/button/Button'
import { TransferDialog } from './dialogs/TransferDialog'
import { SwapDialog } from './dialogs/SwapDialog'

export function ButtonGroup() {
  const [isTransferDialogOpen, setIsTransferDialogOpen] = useState(false)
  const [isSwapDialogOpen, setIsSwapDialogOpen] = useState(false)

  return (
    <div className="flex gap-3">
      <QuickActionButton onClick={() => setIsSwapDialogOpen(true)} Icon={ArrowUpDownIcon}>
        Swap
      </QuickActionButton>
      <QuickActionButton onClick={() => setIsTransferDialogOpen(true)} Icon={TransferIcon}>
        Transfer
      </QuickActionButton>

      <TransferDialog open={isTransferDialogOpen} setOpen={setIsTransferDialogOpen} />
      <SwapDialog open={isSwapDialogOpen} setOpen={setIsSwapDialogOpen} />
    </div>
  )
}

interface QuickActionButtonProps extends PropsWithChildren {
  Icon: LucideIcon | FC<SVGProps<SVGElement>>
  onClick: () => void
}

function QuickActionButton({ children, Icon, onClick }: QuickActionButtonProps) {
  return (
    <Button
      className="flex flex-1 items-center gap-3 rounded-sm border border-primary-bg/10 bg-primary-bg/5 px-4 py-3.5 text-primary-bg text-sm transition-colors hover:bg-primary-bg/10 hover:text-primary-bg"
      onClick={onClick}
    >
      <Icon className="h-5 w-5" />
      {children}
    </Button>
  )
}
